module.exports = __webpack_public_path__ + "img/winerackdog11.b369195a.jpg";